import { Component, Input, ContentChild, TemplateRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common'; 

@Component({
  selector: 'rms-slider',
  templateUrl: './rms-slider.component.html',
  styleUrls: ['./rms-slider.component.scss'],
  imports: [MatIconModule, CommonModule]
})
export class RmsSliderComponent {

  @Input() items: any[] = [];
  @Input() pageSize: number = 5;
  @ContentChild('item') itemTemplate!: TemplateRef<any>;
  @ContentChild('static', { read: TemplateRef }) staticTemplate?: TemplateRef<any>;
  currentPage = 0;


  get effectivePageSize() {
    return this.staticTemplate ? this.pageSize - 1 : this.pageSize;
  }


  get totalPages(): number {
    return Math.max(1, Math.ceil(this.items.length / this.effectivePageSize));
  }


  next() {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
    }
  }

  prev() {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }
  get translateX(): number {
    return this.currentPage * 100;
  }


}
